module.exports = __webpack_public_path__ + "img/logo-white.e9836c70.svg";